import { differenceInSeconds } from "date-fns";

export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match("rgba")) {
    let triplet = hex.slice(5).split(",").slice(0, -1).join(",");
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");

    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }

    c = "0x" + c.join("");

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",");
  }
};

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30) return `${Math.floor(difference / 86400)} d`;
  else if (difference < 86400 * 30 * 12) return `${Math.floor(difference / 86400 / 30)} mon`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`;
}

export function generateRandomId() {
  let tempId = Math.random().toString();
  let uid = tempId.substring(2, tempId.length - 1);
  return uid;
}

export function cmnFormatDate(input, format = "date") {
  let date;

  if (!input) {
    return "";
  } else if (typeof input === "string") {
    date = new Date(input);
  } else if (typeof input === "number") {
    let formatInput = input;
    if (10 == Math.abs(Math.trunc(formatInput)).toString().length) {
      formatInput = input * 1000;
    }
    date = new Date(formatInput);
  } else if (Array.isArray(input) && input.length === 1 && typeof input[0] === "number") {
    let formatInput = input[0];
    if (10 == Math.abs(Math.trunc(formatInput)).toString().length) {
      formatInput = input[0] * 1000;
    }
    date = new Date(formatInput);
  } else {
    return "Invalid";
  }

  // Ensure the Date object is valid
  if (isNaN(date.getTime())) {
    return "Invalid";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  if (format === "date") {
    return `${year}-${month}-${day}`;
  } else if (format === "datetime") {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } else if (format === "datetime2") {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  } else {
    return "Invalid";
  }
}

export const cmnSetValByPath = (obj, path, value) => {
  let keys = path.split(/\.|\|/g); // Allow split . or |
  let lastKey = keys.pop(); // Get the last key
  let target = obj; // Reference to the original object

  // Traverse the object to the second last key
  for (let key of keys) {
    if (!(key in target) || typeof target[key] !== "object") {
      target[key] = {}; // Create an object if path is missing
    }
    if (/^[0-9]+$/.test(key)) {
      target = target[parseInt(key)] // Move deeper in array index
    } else {
      target = target[key]; // Move deeper in object
    }
  }

  if (/^[0-9]+$/.test(lastKey)) {
    lastKey = parseInt(lastKey);// last key is array index
  }

  target[lastKey] = value; // Set the final value
}

export const cmnAssignFromBase = (base, dta) => {
  if (!dta || typeof dta !== "object" || Array.isArray(dta)) {
    return base;
  }

  return Object.keys(base).reduce((acc, key) => {
    if (Object.prototype.hasOwnProperty.call(dta, key)) {
      if (typeof base[key] === "object" && typeof dta[key] === "object" && !Array.isArray(base[key]) && !Array.isArray(dta[key])) {
        acc[key] = cmnAssignFromBase(base[key], dta[key]);
      } else {
        acc[key] = dta[key];
      }
    }
    return acc;
  }, Array.isArray(base) ? [...base] : { ...base });
};
